"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _HBMenuItemDivider = _interopRequireDefault(require("../HBMenu/HBMenuItemDivider"));
var _HBMenuItem = _interopRequireWildcard(require("../HBMenu/HBMenuItem"));
var _HBMenuSectionTitle = _interopRequireDefault(require("../HBMenu/HBMenuSectionTitle"));
var _react = _interopRequireDefault(require("react"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBMenu = require("./HBMenu.styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _HBMenuItemList = function HBMenuItemList(_ref) {
  var menuItems = _ref.menuItems,
    size = _ref.size,
    subMenuSize = _ref.subMenuSize,
    hideArrowIconInSubmenu = _ref.hideArrowIconInSubmenu;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, menuItems.map(function (item, index) {
    switch (item.type) {
      case 'divider':
        return /*#__PURE__*/_react["default"].createElement(_HBMenuItemDivider["default"], {
          key: index,
          margin: item.margin
        });
      case 'section':
        return /*#__PURE__*/_react["default"].createElement(_HBMenuSectionTitle["default"], {
          key: index,
          item: item,
          size: size
        });
      case 'submenu':
        // There's an issue extracting this to a separate file
        // due to circular dependencies
        return /*#__PURE__*/_react["default"].createElement(_reactDropdownMenu.Sub, {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_HBMenuItem["default"], {
          item: _objectSpread(_objectSpread({}, item), {}, {
            type: 'item'
          }, !hideArrowIconInSubmenu ? {
            rightIcon: /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null)
          } : {}),
          size: size,
          itemContainerComponent: StyledSubTrigger
        }), /*#__PURE__*/_react["default"].createElement(StyledSubContent, {
          $maxHeight: item.maxHeight
        }, /*#__PURE__*/_react["default"].createElement(_HBMenuItemList, {
          menuItems: item.menuItems,
          size: subMenuSize || size
        })));
      default:
        return /*#__PURE__*/_react["default"].createElement(_HBMenuItem["default"], {
          key: index,
          item: item,
          size: size
        });
    }
  }));
};
var _default = exports["default"] = _HBMenuItemList; // -------------------------------- Styles -------------------------------- //
var StyledSubTrigger = (0, _styledComponents["default"])(_reactDropdownMenu.SubTrigger).withConfig({
  displayName: "HBMenuItemList__StyledSubTrigger",
  componentId: "sc-hgk3hs-0"
})(["", " ", ""], _HBMenu.baseTriggerStyles, _HBMenuItem.baseItemStyles);

// These styles are a duplicate of baseContentStyles
// I tried reusing them but it didn't work for some reason
var StyledSubContent = (0, _styledComponents["default"])(_reactDropdownMenu.SubContent).withConfig({
  displayName: "HBMenuItemList__StyledSubContent",
  componentId: "sc-hgk3hs-1"
})(["border-radius:2px;box-shadow:", ";background:", ";padding:8px 0;max-height:", ";overflow-y:auto;margin-left:4px;"], "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008), _colors["default"].white, function (props) {
  return props.$maxHeight || 'unset';
});
//# sourceMappingURL=HBMenuItemList.js.map